import { Form } from 'antd';
import { FormProviderProps } from 'antd/es/form/context';
import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import { authActions } from '@store/auth/auth.slice';

import { RouteEnum } from '@enum/route.enum';
import { useRegistrationMutation } from '@hook/auth/auth.hooks';
import { useMutation } from '@hook/common/use-mutation.hook';
import { useStoreDispatch, useStoreSelector } from '@hook/store/store.hooks';
import { isString } from '@util/data/is-exist';

export const useSignUp = () => {
  const dispatch = useStoreDispatch();
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const { error, isLoading } = useStoreSelector((state) => state.auth);
  const { action } = useMutation(useRegistrationMutation(), authActions, authActions.setRegistration);

  const onSignUp: FormProviderProps['onFormFinish'] = (_, { values }) =>
    action({
      email: values.email,
      password: values.password,
      profile: {
        name: values.profile.name,
        lastname: values.profile.lastname,
        company: isString(values.profile.company) ? values.profile.company : undefined,
      },
    });

  const onSignInPage = useCallback(() => {
    dispatch(authActions.resetErrors());
    form.resetFields();
    navigate(RouteEnum.Login.path);
  }, []);

  return {
    form,
    error,
    isLoading,
    onSignUp,
    onSignInPage,
  };
};
